<!--
  - Copyright (C) 2021 Corsair M360, Inc - All Rights Reserved.
  - Unauthorized copying of this file, via any medium is strictly prohibited.
  - Proprietary and confidential.
  -->
<template>
  <div>
    <ul class="rightMenu">
      <li>
        <v-btn text plain depressed link class="link-btn"
               :href="getURLLocalGlobal('/resources/herbmedpro/herb-list/')"
               @click="goToPage('/resources/herbmedpro/herb-list/', $event)">
          Herb List
        </v-btn>
      </li>
      <!--      <li style="display: none">-->
      <!--        <v-btn link :href="getURLLocalGlobal('/resources/herbmedpro/advanced-search/')" text plain depressed>-->
      <!--          Advanced Search-->
      <!--        </v-btn>-->
      <!--      </li>-->
      <li>
        <v-btn text plain depressed link class="link-btn" :href="getURLLocalGlobal('/resources/herbmedpro/help/')"
               @click="goToPage('/resources/herbmedpro/help/', $event)">
          Help
        </v-btn>

      </li>
      <li>
        <v-btn text plain depressed link class="link-btn" :href="getURLLocalGlobal('/resources/herbmedpro/about/')"
               @click="goToPage('/resources/herbmedpro/about/', $event)">
          About HerbMedPro&trade;
        </v-btn>
      </li>
      <li>
        <v-btn text plain depressed link class="link-btn" :href="getURLLocalGlobal('/resources/herbmedpro/sponsors/')"
               @click="goToPage('/resources/herbmedpro/sponsors/', $event)">
          Sponsorship of HerbMedPro&trade;
        </v-btn>
      </li>
      <li>
        <v-btn text plain depressed link class="link-btn" :href="getURLLocalGlobal('/resources/herbmedpro/licensing/')"
               @click="goToPage('/resources/herbmedpro/licensing/', $event)">
          Licensing
        </v-btn>
      </li>
    </ul>
  </div>
</template>

<script>
import globalMixins from "@/mixins/globalMixins";

export default {
  name: 'HmpRightMenu',

  mixins: [globalMixins],

  data: () => ({}),

  created() {

  }
}
</script>

<style>

</style>
